/* tslint:disable:variable-name */
/* eslint-disable @typescript-eslint/camelcase */

export const white = '#ffffff';
export const background_800 = '#1d2129';
export const background_500 = '#4a4d54';
export const background_300 = '#777a7f';
export const background_200 = '#a5a6a9';
export const background_150 = '#d2d3d4';
export const background_100 = '#dddedf';
export const background_50 = '#e8e8e9';
export const background_20 = '#f3f4f4';
export const blue_500 = '#115c7c';
export const blue_400 = '#187ba5';
export const blue_300 = '#1c89b7';
export const blue_200 = '#49a1c5';
export const blue_100 = '#8dc4db';
export const blue_50 = '#d2e7f1';
export const red_500 = '#b21010';
export const red_400 = '#ca1212';
export const red_300 = '#d72f1b';
export const red_200 = '#df5949';
export const red_100 = '#e78276';
export const red_50 = '#f7d5d1';
export const green_500 = '#336a3b';
export const green_400 = '#377d42';
export const green_300 = '#4b9156';
export const green_200 = '#6fa778';
export const green_100 = '#93bd9a';
export const green_50 = '#dbe9dd';
export const orange_500 = '#c16900';
export const orange_400 = '#e07a00';
export const orange_300 = '#f99721';
export const orange_200 = '#faac4d';
export const orange_100 = '#fbc17a';
export const orange_50 = '#feead3';
export const text_800 = '#2a2a2e';
export const text_500 = '#737373';
export const text_300 = '#b1b1b3';
export const text_100 = '#f9f9fa';
export const text_white = '#ffffff';
export const alpha_black_80 = 'rgba(0, 0, 0, 0.8)';
export const alpha_black_60 = 'rgba(0, 0, 0, 0.6)';
export const alpha_black_40 = 'rgba(0, 0, 0, 0.4)';
export const alpha_black_15 = 'rgba(0, 0, 0, 0.15)';
export const alpha_white_80 = 'rgba(255, 255, 255, 0.8)';
export const alpha_white_60 = 'rgba(255, 255, 255, 0.6)';
export const alpha_white_40 = 'rgba(255, 255, 255, 0.4)';
export const alpha_white_30 = 'rgba(255, 255, 255, 0.3)';
export const alpha_white_20 = 'rgba(255, 255, 255, 0.2)';
